module.exports = __webpack_public_path__ + "img/enerman.e8281131.svg";